import React from 'react';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

const MapControlButtonGroup = ({ buttons }) => {
  const styles = {
    backgroundColor: 'white',
    borderRadius: '4px',
    lineHeight: '14px',
    fontSize: '12px',
    padding: '9px',
    minHeight: 'auto',
    minWidth: 'auto',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    textTransform: 'unset'
  }
  return (
    <ButtonGroup variant="contained" aria-label="contained primary button group">
      {
        buttons.map(({title, text, disabled, active, onClick, children}, index) => 
          <Button key={index} variant="outlined" style={styles} disabled={disabled} className={`overlayControl ${(active ? "active" : "")}`}
            title={title} onClick={onClick}>
            {text}
            {children}
          </Button>
        )
      }
    </ButtonGroup>
  )
}

export default MapControlButtonGroup;